module.exports = __webpack_public_path__ + "static/Psylaris-b472a3a212b56460c1306de595078284.jpg";